import { ButtonGroup, Card, LoadingSpinner, Modal, Tooltip, Icon } from 'pepsico-ds'
import React, { useEffect, useState, useRef } from 'react'
import ModalFilters from './ModalFilters'
import { formatNumberWithCommas, returnHyphenIfNull, handleDomToImgDownloadPdf } from '../../utils/utils'
import { useSelector } from 'react-redux'
import { localStoreKeys } from '../../constants/localStoreKeys'
import { Col, Row, Button, Table } from 'antd'
import InforIcon from "../Icons/InfoIcon";
import CommonTable from '../Table/CommonTable'
import DoubleDonutChart from '../Charts/PieChart/DoubleDonutChart'
import LegendList from '../Charts/Legend/LegendList'
// import MapWithShapes from '../Charts/Map/MapWithCircles'
import RadarChartComponent from '../Charts/ResilincChart/RadarChartComponent'
// import ReactTooltip from 'react-tooltip';
import SingleBarChart from '../Charts/SpendAnalyticsChart/SingleBarChart';
import { urlConstants } from '../../constants/urlConstants';
import NoData from '../NoData/NoData'
import SpendDonutChart from '../Charts/SpendAnalyticsChart/SpendDonutChart'
import { trackModalView, getModalAttributes } from '../../utils/fullstory-utils';
import CustomButtons from '../Cards/CustomButtons'
import DropdownWithIcons from './DropdownWithIcons'
import { useToast } from '../../components/Toast/ToastContext';
import Vector from '../../assets/Vector.png'
import EDF_checked from "../../../src/assets/EDF_checked.svg";
import { staticNotes } from '../../constants/staticNotes';

const cellDataFunction = (ctx) => {
    const colId = ctx.column.id
    if(ctx.row.original[colId]==null) {
        return <div>-</div>
    }
    return <div>{ctx.row.original[colId]}</div>
}
const columns = [
    { columnKey: 'a', header: '' },
    { columnKey: 'studyName', header: "Study Name", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    // { columnKey: 'studyDescription', header: "Study Description", size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'createdOn', header: "Created On (YYYY-MM-DD HH:MM:SS)", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'contacteEmail', header: "Contact Email", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'personna', header: "Persona", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'bu', header: "Sector - BU", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'category', header: "Category (L1)", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    // { columnKey: 'teamName', header: "Team Name", size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'status', header: "Status", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'excludes', header: "Discovered Suppliers", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'includes', header: "Shortlisted Suppliers", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
]



function ForestreetModal({ openModal, setOpenModal, userData, selectedYear, capability, userDataLandingPage, landingPageFilters, appName }) {
    const [loader, setLoader] = useState(true)
    const [forestreetData, setForestreetData] = useState({})
    const [tableData, setTableData] = useState([])
    const [buttonGroupItems, setButtonGroupItems] = useState([])
    const feedbackFormUrl = useSelector((state) => state?.localData?.data[localStoreKeys.feedbackFormUrl]);
    const isLoading = useSelector((state) => state?.loader?.isLoading);

    const forestreetRef = useRef();
    const supplierSectorBURef = useRef();
    const supplierSectorCategoryRef = useRef();
    
    const getForestreetData = (value) => {
        let appList = [];
        if(value?.data?.type==="SUCCESS_FORESTREET_DETAIL_VIEW_ACTION") {
            setForestreetData(value.data)
            appList = value?.data?.appData
        }
        if (value.modalName === "ForeStreet" && appList && appList.length > 0) {
            const tempbuttonGroupItems = [
                { 
                    icon: "ondemand_video", 
                    label: "", 
                    onClick: () => window.open(urlConstants.forestreetVideo, "_blank") 
                },
                ...(appList // Ensure this returns an array even if appList is null
                    ?.filter(item => item.isActive)
                    .map(item => ({
                        label: item.app.replace(" (F)", ""),
                        onClick: () => window.open(item.url, "_blank"),
                    })) ?? []) // The nullish coalescing operator provides the fallback
            ];
            setButtonGroupItems(tempbuttonGroupItems);
        }
        const currentYear = new Date().getFullYear()
        // setIsYTDDisplay(currentYear == value.fromDateSelected?.[0]?.["displayText"] ? true : false)
    }

    // {
    //     "suppliersAccepted": null,
    //     "numberOfSupplierDiscovered": null,
    //     "supplierAcceptanceRate": null,
    //     "numberOfStudies" :null,
    //     "published": null,
    //     "workInProgress" : null,
    //     "SupplierStudiesDto" : [
    //       {
    //       "studyName" : null,
    //      "studyDescription" : null,
    //      "createdOn" : null,
    //      "contacteEmail" : null,
    //      "teamName" : null,
    //      "status" : null
    //     }
    //     ]
    //     "refreshFrequency": "30 days",
    //     "lastUpdate": "Mar 2025",
        
    //     "apps": [
    //         {
    //             "app": "Forestreet (F)",
    //             "url": "https://ailsa.forestreet.com/sign-in-sso",
    //             "isActive": true,
    //             "chartDisplay": true
    //         },
    //         {
    //             "app": "Veridion (V)",
    //             "url": "https://platform.veridion.com/",
    //             "isActive": true,
    //             "chartDisplay": true
    //         }
    //     ],
    //   "owner" : ""
    // }

    const inputData = forestreetData?.supplierStudiesData
    const supplierStudiesData = inputData?.map(item => ({
        ...item,
        createdOn: item.createdOn.replace(" +00:00", "")
    }));
    // console.log("forestreetData",supplierStudiesData)
    const sectorCategoryStudyCount = forestreetData?.sectorCategoryStudyCount
    const sectorBuStudyCount = forestreetData?.sectorBuStudyCount
    const sectorBuColor = forestreetData?.sectorBuColor
    const sectorCategoryColor = forestreetData?.sectorCategoryColor

    
    const transformedBUData = sectorBuStudyCount?.map(item => ({
        value: item.count,
        sectorColor: item.sectorColorCode?item.sectorColorCode:"#000000",
        color: item.colorCode?item.colorCode:"#000000",
        name: item.bu,
        category: item.sector,
      }));
      
    
    const transformedCategoryData = sectorCategoryStudyCount?.map(item => ({
        name: item.category,
        category: item.sector,
        value: item.count,
        sectorColor: item.sectorColorCode?item.sectorColorCode:"#000000",
        color: item.colorCode?item.colorCode:"#000000",
      }));

    const uniqueSectorValuesForBUChart = new Set(transformedBUData?.map(item => item.category));
    const multipleSectorFlagForBUChart = uniqueSectorValuesForBUChart?.size > 1;
    
    const suppliersAccepted = forestreetData?.headerDetails?.suppliersAccepted
    const numberOfSupplierDiscovered = forestreetData?.headerDetails?.numberOfSupplierDiscovered
    const supplierAcceptanceRate = forestreetData?.headerDetails?.supplierAcceptanceRate

    const uniqueSectorValuesForCategoryChart = new Set(transformedCategoryData?.map(item => item.category));
    const multipleSectorFlagForCategoryChart = uniqueSectorValuesForCategoryChart?.size > 1;

    
    const workInProgress = forestreetData?.headerDetails?.workInProgress
    const numberOfStudies = forestreetData?.headerDetails?.numberOfStudies
    const published = forestreetData?.headerDetails?.published

    const supplierEnrichmentScore = forestreetData?.headerDetails?.supplierEnrichmentScore
    const averageDiffToPublish = forestreetData?.headerDetails?.averageDiffToPublish

    const isEDFIntegrated = forestreetData?.edfintegrated;


    const columnsToInclude = ["STUDY NAME", "CREATED ON (YYYY-MM-DD HH:MM:SS)", "CONTACT EMAIL", "PERSONA", "SECTOR - BU", "CATEGORY (L1)", "STATUS", "DISCOVERED SUPPLIERS", "SHORTLISTED SUPPLIERS"]

    const columnMapping = {
        "studyName": "STUDY NAME",
        "createdOn": "CREATED ON (YYYY-MM-DD HH:MM:SS)",
        "contacteEmail": "CONTACT EMAIL",
        "personna": "PERSONA",
        "bu": "SECTOR - BU",
        "category": "CATEGORY (L1)",
        "status": "STATUS",
        "excludes": "DISCOVERED SUPPLIERS",
        "includes": "SHORTLISTED SUPPLIERS"
      }
      // Track modal view when opened
    const MODAL_TITLE = 'Supplier Discovery';
          useEffect(() => {
              if (openModal) {
                  trackModalView(`${MODAL_TITLE} ${capability}`, 'view');
              }
          }, [openModal, capability]);
      
          const handleClose = () => {
              trackModalView(`${MODAL_TITLE} ${capability}`, 'close');
              setOpenModal(false);
          };
          const { showToast } = useToast();


          
          const checkPDFDownloaded = () => {}
    
    
    return (
        <Modal
            onCloseModal={handleClose}
            primaryButtonProps={{
                //onClick: () => setOpenModal(!openModal),
                onClick: handleClose,
                size: "medium",
                text: "Close",
                variant: "primary",
            }}
            showPrimaryButton={true}
            showLink={false}
            showSecondaryButton={false}
            showTertiaryButton={false}
            showAuxiliaryButton={false}
            showSlot={true}
            showModal={openModal}
            closeOnOutsideClick={false}
            hideCloseButton={false}
            type="XL"
            {...getModalAttributes(`${MODAL_TITLE} ${capability}`)}
        >
            <div ref={forestreetRef}>
                <div className="modal-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>
                        {userData.FirstName}, the total number of Discovered Suppliers Shortlisted through Forestreet is <b>{suppliersAccepted ? formatNumberWithCommas(suppliersAccepted) : 0}</b>
                        {
                            isEDFIntegrated &&
                            <Tooltip direction="bottom" text={staticNotes.EDF_NOTE}>
                                <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible", marginBottom: "7px" }} />
                            </Tooltip>
                        }
                    </span>
                    {
                        isLoading ? (
                            <></>
                        ) :                    
                        <>
                        
                            <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                <CustomButtons 
                                    isModal={true} 
                                    appList={[
                                        { 
                                            icon: 'ondemand_video', 
                                            label: '', 
                                            url: "https://pepsico.sharepoint.com/:v:/r/teams/DigitalProcurement-BuyersConsolePOC/Shared%20Documents/General%20-/Workstream%20Documentation/Background,%20Discovery%20%26%20Requirements/App%20Videos/Forestreet%20Video.mp4?csf=1&web=1&e=6GdkdB" 
                                        },
                                        ...(forestreetData?.appData ?? [])
                                    ]}   
                                />
                                {/* <button onClick={() => handleDomToImgDownloadPdf(forestreetRef, "Forestreet_Modal")}>PDF</button> */}
                                <span style={{float: 'right', position: 'relative', right: '2rem', bottom: '0.6rem'}}>
                                    <DropdownWithIcons modalRef={forestreetRef} kpiName={"Forestreet_Modal"} isModal={true} checkPDFDownloaded={checkPDFDownloaded}/>
                                </span>
                            </span>
                        </>
                    }
                </div>
                {/* <div className="modal-update-frequesncy" style={{ marginBottom: "5px", display: "flex" }}><Icon alt="" icon="info" size="small" /> &nbsp; {staticNotes.SUPPLIER_DISCOVERY_EDF_NOTE}</div> */}
            
                {(forestreetData?.lastUpdate) && <div className="modal-update-frequesncy">Data As On: {returnHyphenIfNull(forestreetData?.lastUpdate)} | Refresh Frequency: {returnHyphenIfNull(forestreetData?.refreshFrequency)}</div>}
                <ModalFilters modalName={"ForeStreet"} selectedYear={selectedYear} capability={capability} userData={userDataLandingPage} onParentCallback={getForestreetData} landingPageFilters={landingPageFilters} setLoader={setLoader} appName={appName} />
                <br />
                {
                    isLoading ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
                            <LoadingSpinner size={{ height: '80px', width: '80px' }} />
                        </div>
                        :
                        <>
                            <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%", position: 'relative' }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Card style={{ height: '100%',display:'flex' }}>
                                <div className='header-kpi-wrapper'>
                                {
                                    suppliersAccepted === null || suppliersAccepted === undefined ? '' : <>
                                        <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                                            <>
                                                <div className="spend-modal-alphanumeric-value">
                                                    <div className='spend-modal-numeric-value' style={{ color: '#008251' }}>{formatNumberWithCommas(suppliersAccepted)}</div>
                                                    <div className='spend-modal-numeric-value'>/</div>
                                                    <div className='spend-modal-numeric-value' style={{ color: '#005cbc' }}>{formatNumberWithCommas(numberOfSupplierDiscovered)}</div>
                                                </div>
                                                <div className='spend-modal-total-spend-text'>
                                                    # of suppliers <span style={{ color: '#008251' }}>Shortlisted</span> vs # of suppliers <span style={{ color: '#005cbc' }}>Discovered</span>
                                                    &nbsp;<InforIcon text="This data is only for published Studies" />
                                                </div>
                                            </>
                                        </Col>
                                    </>
                                }
                                {
                                    suppliersAccepted === null || suppliersAccepted === undefined ? '' : <>
                                        <div className="compass-modal-divider-verticle" />
                                        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                            <>
                                                <div className="spend-modal-alphanumeric-value">
                                                    <div className='spend-modal-numeric-value' style={{ color: '#008251' }}>{supplierAcceptanceRate || 0}%</div>
                                                    {/* <div className='spend-modal-numeric-value'>/</div>
                                                    <div className='spend-modal-numeric-value' style={{ color: '#94D6F0' }}>{numberOfSupplierDiscovered}</div> 
                                                    */}
                                                </div>
                                                <div className='spend-modal-total-spend-text'>Suppliers <span style={{ color: '#008251' }}>Shortlist</span> %</div>
                                                
                                            </>
                                        </Col>
                                    </>
                                }
                                {/* {
                                    supplierAcceptanceRate === null || supplierAcceptanceRate === undefined ? '' : <>
                                        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                            <>
                                                <div className="spend-modal-alphanumeric-value">
                                                    <div className='spend-modal-numeric-value' style={{ color: '#008251', fontSize: "20px" }}>{supplierAcceptanceRate || 0}%</div>
                                                </div>
                                                <div className='spend-modal-total-spend-text'>Suppliers <span style={{ color: '#008251' }}>Acceptance</span> Rate</div>
                                            </>
                                        </Col>
                                    </>
                                } */}
                                {
                                    numberOfStudies === null || numberOfStudies === undefined ? '' : <>
                                        <div className="compass-modal-divider-verticle" />
                                        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                            <>
                                                <div className="spend-modal-alphanumeric-value">
                                                    <div className='spend-modal-numeric-value'>{numberOfStudies || 0}</div>
                                                </div>
                                                <div className='spend-modal-total-spend-text'>Total # of studies: Published ({published || 0}) WIP ({workInProgress || 0})</div>
                                            </>
                                        </Col>
                                    </>
                                }
                                {
                                // supplierEnrichmentScore === null || supplierEnrichmentScore === undefined ? '' : 
                                    <>
                                        <div className="compass-modal-divider-verticle" />
                                        <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                                            <>
                                                <div className="spend-modal-alphanumeric-value">
                                                    <div className='spend-modal-numeric-value'  style={{ display: "flex" }}>
                                                        {supplierEnrichmentScore === null || supplierEnrichmentScore === undefined ? 'N/A':supplierEnrichmentScore+"%" || 0}
                                                    {/* <div style={{ position: 'absolute', top: 10, right: 0 }}> */}
                                                        <sup style={{ }}>
                                                            <Tooltip  direction="left" text={
                                                                <><div style={{ fontWeight: "bold" }}>This indicates the quality of intelligence provided by the tool <br/>for suppliers across the following parameters:</div>
                                                                <div>Domain</div>
                                                                <div>Size</div>
                                                                <div>Revenue</div>
                                                                <div>Name</div>
                                                                <div>Description</div>
                                                                <div>Founded Year</div>
                                                                <div>HQ City</div>
                                                                <div>HQ Country</div>
                                                                <div>Contact Number</div>
                                                                <div>Contact Email</div>
                                                                <div>Actual Revenue</div>
                                                                <div>Founder's name</div>
                                                                <div>CEO</div>
                                                                </>
                                                            }>
                                                                <Icon alt="" icon="info" size="small" />
                                                            </Tooltip>
                                                        </sup>
                                                    </div>    
                                                    {/* </div> */}
                                                    {/* <InforIcon style={{ position: 'absolute', top: 10, right: 0 }} text={
                                                        <><div style={{ fontWeight: "bold", fontSize: "12px" }}>This indicates the quality of intelligence provided by the tool for suppliers across the following parameters:</div>
                                                        <div>Domain</div>
                                                        <div>Size</div>
                                                        <div>Revenue</div>
                                                        <div>Name</div>
                                                        <div>Description</div>
                                                        <div>Founded Year</div>
                                                        <div>HQ City</div>
                                                        <div>HQ Country</div>
                                                        <div>Contact Number</div>
                                                        <div>Contact Email</div>
                                                        <div>Actual Revenue</div>
                                                        <div>Founder's name</div>
                                                        <div>CEO</div>
                                                        </>
                                                    } /> */}
                                                </div>
                                                <div className='spend-modal-total-spend-text'>Supplier Intelligence Enrichment Score</div>
                                            </>
                                        </Col>
                                    </>
                                }
                                {
                                    numberOfStudies === null || numberOfStudies === undefined ? '' : <>
                                        <div className="compass-modal-divider-verticle" />
                                        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                            <>
                                                <div className="spend-modal-alphanumeric-value">
                                                    <div className='spend-modal-numeric-value'>~3.5 mins</div>
                                                </div>
                                                <div className='spend-modal-total-spend-text'>Average Platform Discovery Time</div>
                                            </>
                                        </Col>
                                    </>
                                }
                                {/* {
                                    averageDiffToPublish === null || averageDiffToPublish === undefined ? '' : <>
                                        <div className="compass-modal-divider-verticle" />
                                        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                            <>
                                                <div className="spend-modal-alphanumeric-value">
                                                    <div className='spend-modal-numeric-value'>{averageDiffToPublish || 0}</div>
                                                </div>
                                                <div className='spend-modal-total-spend-text'>Avg. Study Initiation/Creation to Publish time</div>
                                            </>
                                        </Col>
                                    </>
                                }  */}
                                {/* {
                                    platformUtilizationScore === null || platformUtilizationScore === undefined ? '' : <>
                                        <div className="compass-modal-divider-verticle" />
                                        <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                            <>
                                                <div className="spend-modal-alphanumeric-value">
                                                    <div className='spend-modal-numeric-value'>{platformUtilizationScore || 0}</div>
                                                    <InforIcon style={{ position: 'absolute', top: 10, right: 0 }} text="" />
                                                </div>
                                                <div className='spend-modal-total-spend-text'>Platform Utilization Score</div>
                                            </>
                                        </Col>
                                    </>
                                } */}
                                </div>
                            </Card>
                            </Col> 
                            </Row>
                            <br />

                            <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <div ref={supplierSectorBURef}>
                                    <Card style={{ height: '100%' }} className="archlet-chart-card">
                                        <div className="archlet-chart-title" >
                                            # Suppliers Shortlisted by Sector and BUs &nbsp;<InforIcon text="This data is only for published Studies" />
                                            <span style={{float: 'right'}}>
                                                <DropdownWithIcons modalRef={supplierSectorBURef} kpiName={"# Suppliers Shortlisted by Sector and BUs"} checkPDFDownloaded={checkPDFDownloaded}/>
                                            </span>
                                        </div>
                                        {
                                            transformedBUData && transformedBUData.length>0 ?
                                            <>
                                                <SpendDonutChart countryData={transformedBUData} flag={multipleSectorFlagForBUChart} />
                                                <LegendList legends={sectorBuColor} />
                                                <br/>
                                            </>
                                            : <NoData />
                                        }
                                    </Card>
                                    </div>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <div ref={supplierSectorCategoryRef}>
                                    <Card style={{ height: '100%' }} className="archlet-chart-card">
                                        <div className="archlet-chart-title" >
                                            # Suppliers Shortlisted by Sector and Category &nbsp;<InforIcon text="This data is only for published Studies" />
                                            <span style={{float: 'right'}}>
                                                <DropdownWithIcons modalRef={supplierSectorCategoryRef} kpiName={"# Suppliers Shortlisted by Sector and Category"} checkPDFDownloaded={checkPDFDownloaded}/>
                                            </span>
                                        </div>
                                        {
                                            transformedCategoryData && transformedCategoryData.length>0 ?
                                            <>
                                                <SpendDonutChart countryData={transformedCategoryData} flag={multipleSectorFlagForCategoryChart} />
                                                <LegendList legends={sectorCategoryColor} />
                                                <br/>
                                            </>
                                            : <NoData /> 
                                        }
                                    </Card>
                                    </div>
                                </Col>
                                <br />

                            </Row>
                            <br />
                            <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    {
                                        supplierStudiesData && supplierStudiesData.length>0?
                                            <div className="ph-table-wrapper">
                                                <CommonTable className={"forestreet-table"} columns={columns} data={supplierStudiesData} tableHeader={"Supplier Studies"} enableSorting={true} columnsToInclude={columnsToInclude} columnMapping={columnMapping} tableName={'SUPPLIER STUDIES'}/>
                                            </div>
                                            :<NoData/>
                                    }
                                    
                                </Col>
                            </Row>
                            <br />
                            <div className="spend-modal-manage-spend" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", width: '100%' }}>
                                {
                                    forestreetData?.owners?.length > 0 &&
                                    <div style={{width: '100%'}}>Please reach out to {forestreetData?.owners?.map((contact, index) => (
                                        <React.Fragment key={index}>
                                            <a href={`mailto:${contact.emailId}`} style={{ color: "#005cbc", textDecoration: "None" }}>{contact.emailId}</a>
                                            {index < forestreetData?.owners?.length - 1 && ', '}
                                        </React.Fragment>
                                    ))} for any query on the data displayed.</div>
                                }
                                <div style={{width: '100%'}}>Please fill in <a href={feedbackFormUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>this form</a> for any feedback related to Procurement Hub.</div>
                            </div>
                        </>
                }
                <br/>
            </div>
        </Modal >
    )
}

export default ForestreetModal